export enum AuthStorageKeys {
  ACCESS_TOKEN = "ACCESS_TOKEN",
  REFRESH_TOKEN = "REFRESH_TOKEN",
  REMEMBER_ME = "rememberMe",
}
